// app/packs/controllers/chart/variants/category_breakdown_variant.js
import merge from 'lodash.merge'
import { buildBaseOptions } from '../base_options'
import { fontFamily } from '../theme'

const CATEGORY_BREAKDOWN_DEFAULTS = {
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
        boxWidth: 10,
        boxHeight: 10,
        padding: 16,
        color: '#616770',
        font: { size: 12, family: fontFamily() || 'Roboto' },
      },
    },
    tooltip: {
      enabled: true,
    },
    title: {
      display: true,
      align: 'center',
    },
  },
  scales: {
    x: { display: false },
    y: { display: false },
  },
}

export const CategoryBreakdownVariant = {
  chartType: 'pie',

  applyDataDefaults(datasets) {
    datasets.forEach((dataset) => {
      dataset.borderWidth ??= 0
      dataset.borderColor ??= 'transparent'
    })
  },

  buildOptions(options = {}) {
    return buildBaseOptions(merge({}, CATEGORY_BREAKDOWN_DEFAULTS, options))
  },
}
